import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Services } from "../../../api/Services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import gymgirl from "../../../images/gymgirl.jpg";
import { BASE_URL_MEDIA } from "../../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';


const ProgramsModal = ({ setprogramModal, activeid }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [clientPrograms, setClientPrograms] = useState([]);
  const [duplicateProgram, setDuplicateProgram] = useState([]);

  const [searchProgram, setSearchProgram] = useState("");

  const filterProgram = (e) => {
    setSearchProgram(e.target.value);
    const value = e.target.value;
    const filteredResult = clientPrograms?.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
    setClientPrograms(value == "" ? duplicateProgram : filteredResult);
  };
  //days count
  const daysCount = (days) => {
    const uniqueDaysArray = [
      ...new Set(days.flatMap((workout) => workout.day.split(","))),
    ];

    // Step 2: Count the number of unique days
    const uniqueDaysCount = uniqueDaysArray.length;
    return uniqueDaysCount;
  };
  //excercise count
  const excersieCount = (exercises) => {
    const totalExerciseCount = exercises.reduce((total, workout) => {
      return total + workout.exercises.length;
    }, 0);
    return totalExerciseCount;
  };
  //Api call for get trainer clients programs
  const getTrainerClientPrograms = async (id) => {
    setIsLoading(true);

    try {
      const result = await Services.getTrainerClientAssignedPrograms(id);

      if (result) {
        setprogramModal(true);
        setIsLoading(false);
        setClientPrograms(result?.data?.data?.programs);
        setDuplicateProgram(result?.data?.data?.programs);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTrainerClientPrograms(activeid);
  }, [activeid]);
  return (
    <div>
      <div className="trainer-modal-eventWrapper">
        <div className="trainer-modal trainer-modal-lg">
          {isLoading && (
            <div className="loaderparent-absolute">
              <div className="loader"></div>
            </div>
          )}
          <div className="close" onClick={() => setprogramModal(false)}>
            <i className="fa fa-times"></i>
          </div>

          <div className="search px-2 d-flex justify-content-start">
            <input
              type="text"
              className="form-control input"
              placeholder="Search Program by name"
              value={searchProgram}
              onChange={filterProgram}
            />
          </div>

          {clientPrograms?.length == 0 && !isLoading && (
            <p className="text-center no_found my-4">No Program Found</p>
          )}
          <div className="program-main-wrapper mt-3 px-2">
            <div className="row">
              {clientPrograms?.map((programm) => (
                <div
                  className="col-12 mb-3 col-md-6 col-lg-4 pointer"
                  onClick={() => {
                    navigate(`/programmdetail/${programm?.id}`);
                  }}
                >
                  <div className="program-wrapper">
                    {programm?.image ? (
                      <img
                        src={getImageUrl(programm?.image, BASE_URL_MEDIA)}
                      />
                    ) : (
                      <img src={gymgirl} />
                    )}

                    <div>
                      <div className="content">
                        <p className="name">{programm?.name}</p>
                        <div className="data">
                          {programm?.type === "weekly" ? (
                            <div className="item">
                              <div className="icon">
                                <span>{daysCount(programm?.workouts)}</span>
                                <i className="fa-regular fa-calendar-days"></i>
                              </div>
                              <div className="value">
                                <span>times a week</span>
                              </div>
                            </div>
                          ) : (
                            <div className="item">
                              <div className="icon">
                                <span>{programm?.number_of_weeks}</span>
                                <i className="fa-regular fa-calendar-days"></i>
                              </div>
                              <div className="value">
                                <span>Weeks</span>
                              </div>
                            </div>
                          )}
                          <div className="item">
                            <div className="icon">
                              <span>{programm?.workouts?.length}</span>
                              <i className="fa-solid fa-dumbbell"></i>
                            </div>
                            <div className="value">
                              <span>Workouts</span>
                            </div>
                          </div>
                          <div className="item">
                            <div className="icon">
                              <span>{excersieCount(programm?.workouts)}</span>
                              <i className="fa-solid fa-dumbbell"></i>
                            </div>
                            <div className="value">
                              <span>exercise</span>
                            </div>
                          </div>
                        </div>
                        <div className="community-wrapper">
                          {programm?.community?.logo && (
                            <img
                              src={`${BASE_URL_MEDIA}/storage/assets/uploads/${programm?.community?.logo}`}
                            />
                          )}
                          <div className="info-wrapper">
                            <p className="name">{programm?.community?.name}</p>
                            <p className="country">
                              {programm?.community?.country}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramsModal;
